import { FC, ReactNode } from 'react'
import { ReactComponent as PencilIcon } from 'src/assets/svg/companyProfile/edit-pencil.svg'
import styles from '../companyProfile.module.scss'

interface SectionCardProps {
  children: ReactNode
  // Extra class for a section the spec pins to a fixed height.
  className?: string
  // Shown next to the title once something is selected, e.g. "2 selected".
  count?: string
  // The saved state gives every section an icon; the form state has none.
  icon?: ReactNode
  onEdit?: () => void
  required?: boolean
  subtitle: string
  title: string
}

// The shell every section shares: title, subtitle, an optional "Required" on
// the right, and — once saved — an Edit affordance and a rule above the body.
export const SectionCard: FC<SectionCardProps> = ({
  children,
  className = '',
  count,
  icon,
  onEdit,
  required = false,
  subtitle,
  title,
}) => (
  <section className={`${styles.section} ${className}`}>
    <div className={styles.sectionHead}>
      <div className={styles.sectionHeadText}>
        <div className={styles.sectionTitleRow}>
          <h3 className={styles.sectionTitle}>
            {icon}
            {title}
          </h3>
          {count && <span className={styles.selectedCount}>{count}</span>}
        </div>
        <p className={styles.sectionSubtitle}>{subtitle}</p>
      </div>

      {onEdit ? (
        <button className={styles.editButton} onClick={onEdit} type="button">
          <PencilIcon />
          Edit
        </button>
      ) : (
        required && <span className={styles.requiredHead}>Required</span>
      )}
    </div>

    {onEdit && <hr className={styles.divider} />}

    {children}
  </section>
)
